import './App.css';
import {Routes, Route, Navigate} from "react-router-dom";
import {View} from "react-native-web";
import Login from "./components/Login";
import React, { useState, useEffect } from "react";
import SideBar from "./components/SideBar";
import CreatorSearch from "./components/CreatorSearch";
import Account from "./components/Account";
import AccessToken from "./components/AccessToken";
import {Amplify} from "aws-amplify";
import awsconfig from './aws-exports';
import Grid from "./components/Grid";
import BrandHub from "./components/BrandHub";
import Outreach from "./components/Outreach";
import Campaign from "./components/Campaign";
import ContentHub from "./components/ContentHub";
import EditCampaign from "./components/EditCampaign";
import Message from "./components/Message";
import Join from "./components/Join";
import {useNavigate} from "react-router-dom";
import Browse from "./components/Browse";
import BizRegistration from "./components/BizRegistration";
import ReviewsPage from "./components/ReviewsPage";
import DRolls from "./components/DRolls";
import DRoll from "./components/DRoll";
import EditDRoll from "./components/EditDRoll";
import useInviteAwareAuthRedirect from "./hooks/useInviteAwareAuthRedirect";

export default function App() {
    const navigate = useNavigate();
    const [paymentRequired, setPaymentRequired] = useState(false);

    useInviteAwareAuthRedirect();

    const isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === '[::1]' ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
          )
      );

    awsconfig.oauth = {
        domain: "auth.dupephotos.com",
        scope: [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        redirectSignIn: isLocalhost ? "http://localhost:3000/home/" : "https://business.dupephotos.com/home/",
        redirectSignOut: isLocalhost ? "http://localhost:3000/logout" : "https://business.dupephotos.com/logout",
        responseType: "code"
    };
    Amplify.configure(awsconfig);

    useEffect(() => {
        const handlePaymentRequired = (event) => {
            if (!paymentRequired) {
                setPaymentRequired(true);
                navigate('/content');
            }
        };

        window.addEventListener('paymentRequired', handlePaymentRequired);

        return () => {
            window.removeEventListener('paymentRequired', handlePaymentRequired);
        };
    }, []);


  return (
      <View style={{height: '100vh', backgroundColor: '#f1f1f1'}}>
        <Routes>
            <Route path="/" element={<SideBar paymentRequired={paymentRequired}/>}>
                <Route path="home" element={<BrandHub/>} />
                <Route path="browse" element={<Browse/>} />
                <Route path="creators/search" element={<CreatorSearch/>} />
                <Route path="account" element={<Account/>} />
                <Route path="account/callback" element={<AccessToken/>} />
                <Route path="grid" element={<Grid/>} />
                <Route path="outreach" element={<Outreach/>} />
                <Route path="campaigns/:campaignSlug/edit" element={<EditCampaign/>} />
                <Route path="campaigns/create" element={<EditCampaign/>} />
                <Route path="campaigns/:campaignSlug" element={<Campaign/>} />
                <Route path="drolls" element={<DRolls/>} />
                <Route path="drolls/create" element={<EditDRoll/>} />
                <Route path="drolls/:drollSlug/edit" element={<EditDRoll/>} />
                <Route path="drolls/:drollSlug" element={<DRoll/>} />
                <Route path="content" element={<ContentHub/>} />
                <Route path="messages" element={<Message/>} />
                <Route path="reviews" element={<ReviewsPage/>} />
                <Route path="" element={<Navigate to="/home" />} />
            </Route>
            <Route path="/register" element={<BizRegistration />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/join/:inviteId" element={<Join />}/>
        </Routes>
    </View>
  );
}
